<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="1000px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="background-color: #f5f5f5;">
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <!-- Panel de Expansión para diferentes secciones -->
                <v-expansion-panels v-model="panelExpanded" multiple flat>
                  <!-- DATOS FISCALES -->
                  <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                    <v-expansion-panel-header style="background-color: white;">
                      <div class="d-flex align-center">
                        <v-icon class="mr-3" color="primary">business</v-icon>
                        <span class="text-h6 font-weight-medium">Datos Fiscales</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="background-color: white;">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-combobox
                            v-model="item.client"
                            data-vv-as="cliente"
                            name="client"
                            item-text="business_name"
                            item-value="id"
                            :items="clients"
                            label="Cliente*"
                            autocomplete="off"
                            v-validate="'combobox_required'"
                            :disabled="isViewModal() || !item.flag_edit_client"
                          ></v-combobox>
                          <span class="red--text">{{ errors.first("client") }}</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field 
                            data-vv-as="name" 
                            label="Razon social*" 
                            name="name" 
                            v-model="item.name" 
                            v-validate="'required'" 
                            :disabled="isViewModal() || !item.flag_edit_client"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("name") }}</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-combobox
                            label="Tipo de documento"
                            v-model="item.doc_type"
                            data-vv-as="tipo de documento"
                            name="doc_type"
                            :items="doc_types"
                            item-text="name"
                            item-value="id"
                            autocomplete="off"
                            v-validate="'required'"
                            @blur="query_padron()"
                            :disabled="isViewModal()"
                          ></v-combobox>
                          <span class="red--text">{{ errors.first("doc_type") }}</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            autocomplete="off"
                            data-vv-as="numero de documento"
                            label="Nº de documento*"
                            name="doc_nr"
                            v-validate="'integer|required'"
                            v-model="item.doc_nr"
                            :disabled="isViewModal()"
                            @blur="query_padron()"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("doc_nr") }}</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-combobox
                            label="Condición frente al IVA"
                            v-validate="'required'"
                            v-model="item.iva_condition"
                            data-vv-as="Condición frente al IVA"
                            name="iva_condition"
                            :items="iva_conditions"
                            item-text="name"
                            item-value="id"
                            autocomplete="off"
                            :disabled="isViewModal()"
                          ></v-combobox>
                          <span class="red--text">{{ errors.first("iva_condition") }}</span>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- DATOS DE CONTACTO -->
                  <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                    <v-expansion-panel-header style="background-color: white;">
                      <div class="d-flex align-center">
                        <v-icon class="mr-3" color="primary">contacts</v-icon>
                        <span class="text-h6 font-weight-medium">Datos de contacto</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="background-color: white;">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field 
                            autocomplete="off" 
                            data-vv-as="domicilio" 
                            label="Domicilio*" 
                            name="address" 
                            v-validate="'required'" 
                            v-model="item.address" 
                            :disabled="isViewModal()"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("address") }}</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-combobox
                            v-model="item.provincia"
                            autocomplete="off"
                            data-vv-as="provincia"
                            name="provincia"
                            item-text="name"
                            item-value="id"
                            :items="provincias"
                            label="Provincia"
                            clearable
                            :disabled="isViewModal()"
                          ></v-combobox>
                          <span class="red--text">{{ errors.first("provincia") }}</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            autocomplete="off"
                            data-vv-as="location"
                            label="Localidad"
                            name="location"
                            v-model="item.location"
                            :disabled="isViewModal()"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("location") }}</span>
                        </v-col>  
                        
                        <v-col cols="12" md="6">
                          <v-text-field
                            autocomplete="off"
                            data-vv-as="postal_code"
                            label="Codigo Postal"
                            v-validate="'min:4|max:5'"
                            name="postal_code"                        
                            v-model="item.postal_code"
                            :disabled="isViewModal()"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("postal_code") }}</span>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- DATOS ADICIONALES -->
                  <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                    <v-expansion-panel-header style="background-color: white;">
                      <div class="d-flex align-center">
                        <v-icon class="mr-3" color="primary">settings</v-icon>
                        <span class="text-h6 font-weight-medium">Datos Adicionales</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="background-color: white;">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-combobox
                            label="Tipo de transferencia"
                            v-model="item.transfer_type"
                            data-vv-as="Tipo de transferencia"
                            name="transfer_type"
                            :items="transfer_types"
                            item-text="name"
                            item-value="id"
                            autocomplete="off"
                            :disabled="isViewModal()"
                          ></v-combobox>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-combobox
                            label="Código de Jurisdiccion de IIBB"
                            v-model="item.iibb_code"
                            data-vv-as="Código de Jurisdiccion de IIBB"
                            name="iibb_code"
                            :items="iibb_codes"
                            item-text="name"
                            item-value="id"
                            autocomplete="off"
                            :disabled="isViewModal()"
                          ></v-combobox>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            autocomplete="off"
                            data-vv-as="ingresos_brutos_nr"
                            label="Ingresos Brutos"
                            v-validate="'max:60'"
                            name="ingresos_brutos_nr"                        
                            v-model="item.ingresos_brutos_nr"
                            :disabled="isViewModal()"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("ingresos_brutos_nr") }}</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            autocomplete="off"
                            data-vv-as="external_reference"
                            label="Codigo de referencia externo"
                            v-validate="'max:60'"
                            name="external_reference"                        
                            v-model="item.external_reference"
                            :disabled="isViewModal()"
                          ></v-text-field>
                          <span class="red--text">{{ errors.first("external_reference") }}</span>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- PERCEPCIONES INSCRIPTAS -->
                  <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                    <v-expansion-panel-header style="background-color: white;">
                      <div class="d-flex align-center">
                        <v-icon class="mr-3" color="primary">receipt</v-icon>
                        <span class="text-h6 font-weight-medium">Percepciones Inscriptas</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="background-color: white;">
                      <p class="text-body-2 mb-3">Percepciones a las que está inscripto el receptor</p>
                      <v-row class="mb-3">
                        <v-col md="12" v-if="!isViewModal()">
                          <v-btn small color="blue-grey" class="pl-4 text-white" @click="addImpuestoInscripto()">
                            <v-icon small color="white" class="mr-2">add</v-icon>
                            <span>Agregar percepción</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="header_impuestos"
                        :items="item.impuesto_inscripto"
                        style="border: solid 1px #e0e0e0"
                        :hide-default-footer="true"
                        :items-per-page="100"
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td>
                              <v-combobox
                                :items="percepciones"
                                item-text="name"
                                item-value="id"
                                v-model="props.item.impuesto"
                                :disabled="isViewModal()"
                                dense
                                placeholder="Seleccione una percepción"
                                hide-details
                              />
                            </td>
                            <td class="text-center">
                              <v-tooltip bottom v-if="!isViewModal()">
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small color="red" @click="removeImpuestoInscripto(props.item)">delete</v-icon>
                                </template>
                                <span>Remover</span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- PERCEPCIONES EXENTAS -->
                  <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                    <v-expansion-panel-header style="background-color: white;">
                      <div class="d-flex align-center">
                        <v-icon class="mr-3" color="primary">money_off</v-icon>
                        <span class="text-h6 font-weight-medium">Percepciones Exentas</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="background-color: white;">
                      <p class="text-body-2 mb-3">Percepciones de las que el receptor está exento</p>
                      <v-row class="mb-3">
                        <v-col md="12" v-if="!isViewModal()">
                          <v-btn small color="blue-grey" class="pl-4 text-white" @click="addPercepcionExcento()">
                            <v-icon small color="white" class="mr-2">add</v-icon>
                            <span>Agregar exención</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="header_percepciones_excento"
                        :items="item.percepciones_excento"
                        style="border: solid 1px #e0e0e0"
                        :hide-default-footer="true"
                        :items-per-page="100"
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td>
                              <v-combobox
                                :items="percepciones"
                                item-text="name"
                                item-value="id"
                                v-model="props.item.percepcion"
                                :disabled="isViewModal()"
                                dense
                                placeholder="Seleccione"
                                hide-details
                              />
                            </td>
                            <td>
                              <v-text-field
                                v-model="props.item.certificado_de_excencion"
                                :disabled="isViewModal()"
                                dense
                                hide-details
                                placeholder="Nro. certificado"
                              />
                            </td>
                            <td>
                              <v-text-field
                                v-model="props.item.porcentaje_de_excencion"
                                :disabled="isViewModal()"
                                dense
                                hide-details
                                type="number"
                                placeholder="0.00"
                              />
                            </td>
                            <td>
                              <v-text-field
                                v-model="props.item.desde"
                                :disabled="isViewModal()"
                                dense
                                hide-details
                                type="date"
                              />
                            </td>
                            <td>
                              <v-text-field
                                v-model="props.item.hasta"
                                :disabled="isViewModal()"
                                dense
                                hide-details
                                type="date"
                                clearable
                              />
                            </td>
                            <td>
                              <div v-if="!isViewModal()">
                                <v-file-input
                                  v-model="props.item.certificado_file"
                                  dense
                                  hide-details
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  placeholder="Adjuntar"
                                  prepend-icon="attach_file"
                                  @change="onCertificadoPercepcionFileChange($event, props.item)"
                                />
                              </div>
                              <div v-else-if="props.item.certificado_path">
                                <v-icon small>attach_file</v-icon>
                                <span class="caption">{{ props.item.certificado_path.split('/').pop() }}</span>
                              </div>
                            </td>
                            <td class="text-center">
                              <v-tooltip bottom v-if="!isViewModal()">
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small color="red" @click="removePercepcionExcento(props.item)">delete</v-icon>
                                </template>
                                <span>Remover</span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
        </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import { billingGeneralService } from "@/libs/ws/billingGeneralService";
import { generalService } from "@/libs/ws/generalService";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import { impuestosService } from "@/libs/ws/impuestosService";

export default {
  components: {},
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      show: false,
      panelExpanded: [0, 1, 2, 3, 4], // Todos los paneles abiertos por defecto
      roles: [],
      doc_types: [],
      iva_conditions: [],
      iibb_codes: [],
      clients: [],
      percepciones: [],
      provincias: [],
      header_impuestos: [
        { text: "Percepción", value: "impuesto", sortable: false },
        { text: "Acción", value: "", sortable: false, align: "center", width: "70px" },
      ],
      header_percepciones_excento: [
        { text: "Percepción", value: "percepcion", sortable: false },
        { text: "Certificado", value: "certificado_de_excencion", sortable: false },
        { text: "% Excención", value: "porcentaje_de_excencion", sortable: false, width: "110px" },
        { text: "Desde", value: "desde", sortable: false, width: "140px" },
        { text: "Hasta", value: "hasta", sortable: false, width: "140px" },
        { text: "Adjunto", value: "certificado_path", sortable: false },
        { text: "Acción", value: "", sortable: false, align: "center", width: "70px" },
      ],
      transfer_types: [
        { id: "SCA", name: "TRANSFERENCIA AL SISTEMA DE CIRCULACION ABIERTA" },
        { id: "ADC", name: "AGENTE DE DEPOSITO COLECTIVO" },
      ],
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() {
    this.loadDocTypes();
    this.loadIVAConditions();
    this.loadIIBBCodes();
    this.loadClients();
    this.loadPercepciones();
    this.loadProvincias();
  },
  methods: {
    loadClients() {
      generalService
        .filter({}, Constant.SECTION_CLIENTS)
        .then((response) => {
          this.clients = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    isViewModal() {
      return this.formBtn == "";
    },
    loadPercepciones() {
      generalService.setSection(Constant.SECTION_IMPUESTOS);
      generalService.filter({categoria_impuesto: impuestosService.PERCEPCION }).then((response) => {
        this.percepciones = response.result;
      });
    },
    loadProvincias() {
      generalService.setSection(Constant.SECTION_PROVINCIAS);
      generalService
        .filter()
        .then((response) => {
          this.provincias = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
          this.$toast.error("Ocurrio un error al obtener las provincias.");
        });
    },
    addImpuestoInscripto() {
      this.item.impuesto_inscripto.push({ id: null, impuesto: null });
    },
    removeImpuestoInscripto(item) {
      this.item.impuesto_inscripto.splice(this.item.impuesto_inscripto.indexOf(item), 1);
    },
    addPercepcionExcento() {
      this.item.percepciones_excento.push({
        id: null,
        percepcion: null,
        certificado_de_excencion: null,
        porcentaje_de_excencion: null,
        desde: null,
        hasta: null,
        certificado_path: null,
        certificado_file: null,
        certificado_file_base64: null,
        certificado_file_ext: null,
      });
    },
    removePercepcionExcento(item) {
      this.item.percepciones_excento.splice(this.item.percepciones_excento.indexOf(item), 1);
    },
    onCertificadoPercepcionFileChange(file, item) {
      if (!file) {
        item.certificado_file_base64 = null;
        item.certificado_file_ext = null;
        return;
      }
      item.certificado_file_ext = file.name.split(".").pop();
      const reader = new FileReader();
      reader.onload = (e) => {
        item.certificado_file_base64 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    loadIIBBCodes() {
      this.service.iibb_codes().then((response) => {
        this.iibb_codes = response.result;
      });
    },
    loadDocTypes() {
      billingGeneralService.list_doc_types().then((response) => {
        this.doc_types = response.result;
      });
    },
    loadIVAConditions() {
      billingGeneralService.list_iva_conditions().then((response) => {
        this.iva_conditions = response.result;
      });
    },
    query_padron(){
      if(this.item.doc_nr != null && this.item.doc_type != null){
        this.service
          .query_padron({
            tax_id: this.item.doc_nr,
            doc_type: this.item.doc_type.id,
          })
          .then((response) => {
            console.log(response)
            //TODO: ver si volvio bien y con algun alerta
            if(response.status == true){
              this.item.name = response.result.name;
              this.item.address = response.result.address;
              this.item.location = response.result.location;
              this.item.provincia = response.result.provincia;
              this.item.postal_code = response.result.postal_code;

              this.item.iva_condition = this.iva_conditions.find((x) => x.id == response.result.iva_condition);
              this.item.ingresos_brutos_nr = response.result.ingresos_brutos_nr;                            
            }
          })
          .catch((response) => {
            console.log(response);
            this.$toast.error(response.msg, "Error");
          });
      }
    },
    createItem(e) {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          e.preventDefault();
          const data = {
            id: this.item.id,
            name: this.item.name,
            doc_type: this.item.doc_type.id,
            doc_nr: this.item.doc_nr,
            client: this.item.client.id,
            iva_condition: this.item.iva_condition.id,
            address: this.item.address,
            transfer_type: this.item.transfer_type ? this.item.transfer_type.id : null,
            iibb_code: this.item.iibb_code ? this.item.iibb_code.id : null,
            external_reference: this.item.external_reference || null,
            postal_code: this.item.postal_code || null,
            location: this.item.location || null,
            provincia: this.item.provincia || null,
            ingresos_brutos_nr: this.item.ingresos_brutos_nr || null,
            impuesto_inscripto_arr: (this.item.impuesto_inscripto || [])
              .filter((r) => r.impuesto && r.impuesto.id)
              .map((r) => ({
                id: r.id > 0 ? r.id : null,
                impuesto_id: r.impuesto.id,
              })),
            percepciones_excento_arr: (this.item.percepciones_excento || [])
              .filter((r) => r.percepcion && r.percepcion.id)
              .map((r) => ({
                id: r.id > 0 ? r.id : null,
                percepcion_id: r.percepcion.id,
                certificado_de_excencion: r.certificado_de_excencion || null,
                porcentaje_de_excencion: r.porcentaje_de_excencion || null,
                desde: r.desde || null,
                hasta: r.hasta || null,
                certificado_file_base64: r.certificado_file_base64 || null,
                certificado_file_ext: r.certificado_file_ext || null,
              })),
          };

          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("El " + this.modal_title + " se modifico correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            this.service
              .create(data)
              .then((response) => {
                console.log(response);
                if (response.status == true) {
                  this.$toast.success("El " + this.modal_title + " se creo correctamente", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                console.log(response);
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>
